// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconRefresh.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconRefresh = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M16 6.93799C16 6.60084 15.4345 6.53341 15.2879 6.8537C14.3246 9.06204 11.7277 10.6635 8.6492 10.6972V9.1969C8.6492 8.89346 8.20941 8.70803 7.89528 8.89346L2.65967 12.1132C2.40836 12.265 2.40836 12.5515 2.65967 12.7033L7.89528 15.923C8.20941 16.1085 8.6492 15.9399 8.6492 15.6196V14.1362C12.8377 13.4787 16 10.5286 16 6.95485C16 6.95485 16 6.95485 16 6.93799Z" />
    <path d="M7.35079 6.78626C7.35079 7.08969 7.79058 7.27513 8.10471 7.08969L13.3403 3.86991C13.5916 3.71819 13.5916 3.43161 13.3403 3.27989L8.10471 0.076965C7.79058 -0.108468 7.35079 0.0601075 7.35079 0.3804V1.86386C3.1623 2.52131 0 5.47137 0 9.04517V9.06202C0 9.39917 0.565445 9.4666 0.712042 9.14631C1.67539 6.93798 4.27225 5.33651 7.35079 5.3028V6.78626Z" />
  </BaseIcon>
);

export default IconRefresh;
